import FileSaver from "file-saver";
import React from "react";

const columns = [
  {
    label: "User Name",
    value: "username",
  },
  {
    label: "First Name",
    value: "firstName",
  },
  {
    label: "Last Name",
    value: "lastName",
  },
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Phone",
    value: "phone",
  },
  {
    label: "DOB",
    value: "dob",
  },
  {
    label: "Shop Roster",
    value: "shopRoster",
  },
  {
    label: "Individual Roster",
    value: "individualRoster",
  },
  {
    label: "Status",
    value: "active",
  },
  {
    label: "Level",
    value: "level",
  },
  {
    label: "Pin code",
    value: "pinCode",
  }
];

export const ExportUser = (data) => {
//   console.log({ data });
  // header
  const headers = columns?.map((col) => col?.label);
  // rows
  const rows = data?.map((row) => {
    return columns?.map((header) => {
      const text = `${header?.value}`;
      return row[text];
    });
  });
  // csv data
  const csvData = [headers.join(","), ...rows].join("\r\n");
  //export data
  const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
  FileSaver.saveAs(blob, "user_list.csv");
};
